import React, { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";

import "./Search.scss";

interface Props {
  handleSearch: Function;
  handleClose: React.MouseEventHandler<HTMLDivElement>;
}

export default function Search({ handleSearch, handleClose }: Props) {
  const [searchText, setSearchText] = useState<string>("");
  const [firstAccess, setFirstAccess] = useState<boolean>(true);

  function handleText(e: React.ChangeEvent<HTMLInputElement>): void {
    setSearchText(e.target.value);
  }
  useEffect(() => {
    let timerKey;
    if (!firstAccess) {
      timerKey = setTimeout(() => {
        handleSearch(searchText);
      }, 400);
    }
    return () => {
      setFirstAccess(false);
      clearTimeout(timerKey);
    };
  }, [searchText, handleSearch, firstAccess]);

  return (
    <div className="search_box_container">
      <div className="search_box">
        <div className="search_icon_wrapper">
          <AiOutlineSearch />
        </div>
        <input type="search" id="form1" className="form_input " value={searchText} onChange={handleText} placeholder="Seach Videos, QBanks & more" />
        <div className="close_btn_wrapper" onClick={handleClose}>
          <IoMdClose />
        </div>
      </div>
    </div>
  );
}
